import { PaymentInformationFormFragment } from 'generated/resources/graphql'

import { Employee } from 'modules/core/hooks/useCurrentSession'
import { fromCents } from 'modules/core/lib/formatCurrencyUtils'

export const getPaymentInformationDefaultValues = (
  employee: Employee,
  groupId: number | null | undefined,
  data?: PaymentInformationFormFragment | null,
  groupCurrency?: string | null
) => {
  const fallbackCurrency = groupId
    ? groupCurrency || employee?.legalEntity?.currency
    : employee?.legalEntity?.currency || data?.currency || null

  const defaultReimbursableAmount =
    fromCents(parseInt(data?.reimbursableAmount)) || fromCents(parseInt(data?.amount)) || null

  return {
    payment: data?.expense?.payment ?? '',
    paymentMethod: data?.expense?.paymentMethod,
    reimbursableAmount: defaultReimbursableAmount,
    reimbursableCurrency: data?.reimbursableCurrency || fallbackCurrency,
    creationType: data?.expense?.creationType || null,
    exchangeRate: data?.expense?.exchangeRate || null,
  }
}
